// extracted by mini-css-extract-plugin
export default {"RemoveButton":"RemoveButton_RemoveButton__gkqmG","top_right":"RemoveButton_top_right__27SII"};